// extracted by mini-css-extract-plugin
module.exports = {"category":"JobSelectionMenu_category___5Z0j"};